import React from 'react'

import { StyledFooter } from './styles/StyledFooter'


const Footer = () => {
    return (
        <StyledFooter>
            <p> Made by  <a href="https://github.com/chmette">chmette</a> and <a href="https://github.com/olhanotolga">olhanotolga</a>, based on <a href="https://www.youtube.com/watch?v=ZGOaCxX8HIU">weibenfalk’s tutorial</a> </p>
        </StyledFooter>

    )
}

export default Footer
